import { Button } from "../ui/button";

interface CommandCenterEmptyStateAction {
  readonly label: string;
  readonly onClick: () => void;
  readonly variant?: "default" | "outline" | "ghost";
}

interface CommandCenterEmptyStateProps {
  readonly title: string;
  readonly description: string;
  readonly actionLabel?: string;
  readonly onAction?: () => void;
  readonly actions?: readonly CommandCenterEmptyStateAction[];
}

export function CommandCenterEmptyState({
  title,
  description,
  actionLabel,
  onAction,
  actions,
}: CommandCenterEmptyStateProps) {
  const resolvedActions =
    actions ??
    (actionLabel && onAction
      ? [{ label: actionLabel, onClick: onAction, variant: "outline" as const }]
      : []);

  return (
    <div className="flex flex-1 items-center justify-center px-6 py-10">
      <div className="w-full max-w-xl rounded-lg border border-border/70 bg-card/35 p-6 text-center">
        <h2 className="text-xl font-semibold tracking-tight text-foreground">{title}</h2>
        <p className="mt-2 text-sm leading-6 text-muted-foreground">{description}</p>
        {resolvedActions.length > 0 ? (
          <div className="mt-4 flex flex-wrap items-center justify-center gap-2">
            {resolvedActions.map((action) => (
              <Button
                key={action.label}
                variant={action.variant ?? "outline"}
                onClick={action.onClick}
              >
                {action.label}
              </Button>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
}
